import React, { FC } from "react"

import { ImageType } from "@srcTypes"

import Avatar, { AVATAR_SIZES } from "../Avatar/Avatar"

import "./AvatarPlusInfo.scss"

type AvatarPlusInfoProps = {
  bio?: string,
  image?: ImageType,
  name: string,
}

const AvatarPlusInfo: FC<AvatarPlusInfoProps> = ({
  bio,
  image,
  name,
}) => (
  <div className="AvatarPlusInfo">
    {image && (
      <Avatar
        name={name}
        image={image}
        size={AVATAR_SIZES.S}
      />
    )}
    <div>
      <h6 className="type--text-S font-family--mono color--text-light">
        {name}
        {bio && (
          <>
            <span className="divider">•</span>
            {bio}
          </>
        )}
      </h6>
    </div>
  </div>
)

export default AvatarPlusInfo
